import {createSlice} from "@reduxjs/toolkit";

export const dragAndDropSlice = createSlice({
    name: "dragAndDrop",
    initialState: {
        patientDnD: undefined,
        taskDnD: undefined,
        admissionDnD: undefined,
        creatorDnD: undefined,
        specObject: undefined,
        timestampObject: undefined,
        bmWardMapObject: undefined,
    },
    reducers: {
        setPatientDnD: (state, dnd) => {
            state.patientDnD = dnd.payload;
        },
        setTaskDnD: (state, dnd) => {
            state.taskDnD = dnd.payload;
        },
        setAdmissionDnD: (state, dnd) => {
            state.admissionDnD = dnd.payload;
        },
        setCreatorDnD: (state, dnd) => {
            state.creatorDnD = dnd.payload;
        },
        setSpecObject: (state, dnd) => {
            state.specObject = dnd.payload;
        },
        setTimestampObject: (state, dnd) => {
            state.timestampObject = dnd.payload;
        },
        setBmWardMapObject: (state, dnd) => {
            state.bmWardMapObject = dnd.payload;
        },
    },
});

export const {
    setPatientDnD,
    setTaskDnD,
    setAdmissionDnD,
    setCreatorDnD,
    setSpecObject,
    setTimestampObject,
    setBmWardMapObject,
} = dragAndDropSlice.actions;

export const patientDnD = state => state.dragAndDrop.patientDnD;
export const taskDnD = state => state.dragAndDrop.taskDnD;
export const admissionDnD = state => state.dragAndDrop.admissionDnD;
export const creatorDnD = state => state.dragAndDrop.creatorDnD;
export const specObject = state => state.dragAndDrop.specObject;
export const timestampObject = state => state.dragAndDrop.timestampObject;
export const bmWardMapObject = state => state.dragAndDrop.bmWardMapObject;

export default dragAndDropSlice.reducer;
